import routerOptions0 from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/node_modules/.pnpm/nuxt@3.17.7_@parcel+watcher@2.5.1_@types+node@22.16.4_@vue+compiler-sfc@3.5.17_db0@0.3.2_esli_xj4c33rywu33qsxbz2ds3f7iza/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}